// extracted by mini-css-extract-plugin
module.exports = {"advantage":"Advantage_advantage__39PjP","icon":"Advantage_icon__t-2_C","title":"Advantage_title__3wNj4","description":"Advantage_description__1Y_Uk"};